import React from "react";
import "./bottom-menu.css";

export function MenuBar({ items, activeKey, onSelect, className = "" }) {
  return (
    <nav className={`rr-bottom-menu-root ${className}`} aria-label="Main navigation">
      {items.map((item) => {
        const Icon = item.icon;
        const isActive = item.key === activeKey;
        // Optional per-item accent (e.g. keep Jackpot gold when active).
        const accentStyle = isActive && item.activeColor ? { color: item.activeColor } : undefined;
        return (
          <button
            key={item.key}
            className={`rr-bottom-btn${isActive ? " active" : ""}${item.activeColor ? " rr-bottom-btn--accent" : ""}`}
            onClick={() => onSelect(item.key)}
            type="button"
            aria-label={item.label}
            aria-current={isActive ? "page" : undefined}
            style={accentStyle}
          >
            <span className="rr-bottom-icon-wrap">
              <Icon size={23} filled={isActive} />
              {item.indicator && <span className="rr-bottom-live-dot" aria-hidden="true" />}
            </span>
            <span className="rr-bottom-label" aria-hidden="true">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
